<template>
  <div class="container page" style="background: #1f1c1f;">
    <div class="header">
      <van-nav-bar :title="$t('share.comment_list_title')" class="nav-bar" />
    </div>

    <div class="main">
      <!-- 骨架屏 -->
      <van-skeleton
        v-if="loading"
        row="3"
        title-width="40%"
        avatar
        round
        class="skeleton"
      />

      <!-- 无数据 -->
      <van-empty v-else-if="list.length === 0" :description="$t('share.no_comments')" />

      <!-- 评价列表 -->
      <template v-else>
        <div class="comment-item" v-for="(item, index) in list" :key="index">
          <div class="comment-head">
            <!-- 头像：有头像用头像，没有用名字第一个字 -->
            <div v-if="item.avatar" class="avatar-box">
              <van-image round width="60" height="60" :src="$baseURL+item.avatar" />
            </div>
            <div v-else class="avatar-box" style="width: 60px;height: 60px;">
              <div class="text-avatar">{{ getFirstChar(item.name) }}</div>
            </div>
            <div class="meta">
              <div class="name">{{ item.name }}</div>
              <div class="time">{{ item.create_time }}</div>
            </div>
          </div>
          <div class="content">{{ item.content }}</div>

          <!-- 图片：一行3个，自动换行 -->
          <div v-if="imagesOf(item).length" class="images">
            <div
              class="img"
              v-for="(img, imgIndex) in imagesOf(item)"
              :key="img + '_' + imgIndex"
              @click="preview(imagesOf(item), imgIndex)"
            >
              <van-image fit="cover" radius="10" :src="img" />
            </div>
          </div>
           <!-- 👇 新增：点赞 + 评论区域 -->
            <div class="action-bar">
              <!-- 评论按钮：点击提示会员操作 -->
              <div class="action-item comment" @click="tipMember">
                <span class="icon">💬</span>
                <span class="num">{{ item.comment_count || 0 }}</span>
              </div>
              <!-- 点赞按钮：点击调用接口，已点赞变色 -->
              <div class="action-item like" :class="{liked: item.is_like}" @click="doLike(item, index)">
                <span class="icon">❤️</span>
                <span class="num">{{ item.like_count || 0 }}</span>
              </div>
            </div>
        </div>
        <div style="padding-bottom: 55px;"></div>
      </template>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      loading: true,
      list: [], // 接口数据
      page: 1,
      limit: 10
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    imagesOf(item) {
      const images = item && item.images_arr ? item.images_arr : [];
      return images.slice(0, 3);
    },
    // 评论提示会员操作
    tipMember() {
      this.$toast(this.$t("share.member_action"));
    },
    // 点赞操作
    doLike(item, index) {
      this.$http({
        method: "post",
        url: "commentLike", // 你的点赞接口
        data: {
          comment_id: item.id
        }
      }).then(res => {
        if(res.code === 200) {
          // 前端更新状态和数量
          this.list[index].is_like = !this.list[index].is_like;
          if(this.list[index].is_like) {
            this.list[index].like_count = Number(this.list[index].like_count) + 1;
          } else {
            this.list[index].like_count = Number(this.list[index].like_count) - 1;
          }
          this.$toast(this.$t("share.action_success"));
        } else {
          this.$toast(res.msg);
        }
      })
    },
    // 请求评价列表接口
    getList() {
      this.$http({
        method: "get",
        url: "getUserCommentsList",
      
      }).then(res => {
        res.data.forEach(item => {
          item.images_arr = item.images_arr.map(img => this.$baseURL + img);
        })
        // 数据赋值
        this.list = res.data;
        this.loading = false;
      });
    },
     // 获取名字第一个字（无头像时使用）
    getFirstChar(name = "") {
      const fallback = this.$t("share.anonymous_char");
      if (!name) return fallback;
      return name.charAt(0) || fallback;
    },
    // 图片预览
    preview(images, startPosition) {
      return ImagePreview({
        images,
        startPosition,
        closeable: true
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.container .main {
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}

.skeleton {
  padding: 30px 20px;
  margin: 30px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
}

.comment-item {
  padding: 20px 20px;
  margin: 30px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  box-shadow: 0 2px 8px #000;
}

.comment-head {
  display: flex;
  align-items: center;
}
/* 统一头像外框，保证大小一致 */
.avatar-box {
  margin-right: 16px;
}

/* 文字头像 */
.text-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #f3c7a2;
  color: #222;
  font-size: 48px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.meta {
  flex: 1;
  margin-left: 16px;
  line-height: 40px;
}

.name {
  font-size: 35px;
  font-weight: 700;
  color: #f3c7a2;
}

.time {
  font-size: 25px;
  font-weight: 500;
  color: #9b9b9b;
}

.content {
  margin-top: 16px;
  font-size: 28px;
  font-weight: 500;
  color: #f3c7a2;
  line-height: 44px;
  white-space: pre-wrap;
  word-break: break-word;
}

/* 一行3张图片布局 */
.images {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  gap: 10px;
}

.img {
  width: calc(33.333% - 7px);
  aspect-ratio: 1/1;
}
/* 👇 新增点赞评论样式 */
.action-bar {
  display: flex;
  gap: 40px;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #444;
}
.action-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 26px;
  color: #9b9b9b;
  cursor: pointer;
}
.action-item.like {
  &.liked {
    color: #ff6b6b;
    .icon {
      color: #ff6b6b;
    }
  }
}
.action-item .icon {
  font-size: 30px;
}
</style>
